import { useState, useEffect } from 'react';
import { debounce } from 'global/lib/lodash';

const deb = debounce(
  (ents, toSet) => {
    toSet(ents);
  },
  100,
  { leading: false, trailing: true }
);

export const useResize = (elem) => {
  const [entries, setEntries] = useState([]);

  const resizeObserver = new ResizeObserver((ents) => {
    deb(ents, setEntries);
  });

  useEffect(() => {
    if (elem) {
      resizeObserver.observe(elem);

      return () => {
        resizeObserver.unobserve(elem);
      };
    }
  }, [elem]);

  return {
    entries,
  };
};
